const settings = {
    MNG: {
        ROLE: 1,
    },
    ENGINEER: {
        ROLE: 2,
    },
    BREAKPOINTS: {
        SP: 768,
    },
    GENDER: {
        NOT_SELECTED: '0',
        MALE: '1',
        FEMALE: '2'
    }
}
const menu = {
    MNG: {
        SIGNIN: { PATH: '/mng/signin', PAGE_NAME: 'ログイン' },
        HOME: { PATH: '/mng/engineers', PAGE_NAME: 'エンジニア一覧' },
        SETTINGS: { PATH: '/mng/settings', PAGE_NAME: 'アカウント設定' },
    },
    ENGINEER: {
        SIGNIN: { PATH: '/signin', PAGE_NAME: 'ログイン' },
        HOME: { PATH: '/mypage', PAGE_NAME: 'マイページ' },
        ENGINEER_LIST: { PATH: '/engineers', PAGE_NAME: 'エンジニア一覧' },
        SETTINGS: { PATH: '/settings', PAGE_NAME: 'アカウント設定' },
    },
    SHARE: {
        ENGINEER_LIST: { PATH: '/share/engineers', PAGE_NAME: 'エンジニア一覧' },
    }
}
const statistics = {
    TERMS: {
        LESS_THAN_ONE: 0,
        ONE_OR_MORE: 1,
        TWO_OR_MORE: 2,
        THREE_OR_MORE: 3,
        FIVE_OR_MORE: 5,
    }
}

module.exports = {
    settings: settings,
    menu: menu,
    statistics: statistics
}